
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IndividualGroup } from 'ah-api-gateways';
import GroupListing from '@/app/components/groups/GroupListing.vue';
import GroupInfo from '@/app/components/groups/GroupInfo.vue';
import { AnimatedListingWithSubViewState } from '@/app/components/common/animation/AnimatedListingWithSubView.vue';
import { groupTableFieldsFull, groupTableFieldsMinimal } from '@/app/components/groups/tableFields/groupTableFields';
import GroupEditModal from '@/app/components/groups/GroupEditModal.vue';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';
import { editRoute } from 'ah-common-lib/src/helpers/route';

@Component({
  components: {
    GroupListing,
    GroupInfo,
    GroupEditModal,
    InfoTooltip,
  },
})
export default class GroupsSettingsView extends Vue {
  $refs!: {
    groupListing: GroupListing;
  };

  @Prop({ required: false }) groupId?: string;

  // Auto-set by AnimatedListingWithSubView[animatedState.sync] in template
  private animatedState: AnimatedListingWithSubViewState | null = null;

  get groupTableConfig() {
    return this.$mediaQuery.is('mdDown') && !this.animatedState?.wideList
      ? { tableFields: groupTableFieldsMinimal }
      : { tableFields: groupTableFieldsFull };
  }

  goToGroup(group?: IndividualGroup, replace = false) {
    const route = editRoute(this.$route, {
      params: {
        groupId: !group || this.groupId === group.id ? '' : group.id,
      },
    });
    this.$router[replace ? 'replace' : 'push'](route);
  }

  onGroupDeleted() {
    this.goToGroup(undefined, true);
    this.refreshGroups();
  }

  refreshGroups() {
    if (this.$refs.groupListing) {
      this.$refs.groupListing.loadData();
    }
  }
}
